/* eslint-disable max-len */
export const linksInformation = [
  {
    title: 'Buying Guides',
    content: [
      {
        link: 'https://www.homedepot.com/c/ab/best-mulch-for-your-yard/9ba683603be9fa5395fab90378c2bc5',
        description: 'Best Mulch for Your Yard'
      },
      {
        link: 'https://www.homedepot.com/c/ab/best-pruning-shears-for-your-yard/9ba683603be9fa5395fab909532b5bb',
        description: 'Best Pruning Shears for Your Yard'
      }
    ],
  },
  {
    title: 'Project Guides',
    content: [
      {
        link: ' https://www.homedepot.com/c/ah/how-to-mulch-your-yard/9ba683603be9fa5395fab90328394da',
        description: 'How To Mulch Your Yard '
      },
      {
        link: 'https://www.homedepot.com/c/ah/how-to-plant-flowers/9ba683603be9fa5395fab907d8ef46c',
        description: 'How to Plant Flowers'
      }
    ]
  },
  {
    title: 'Idea Guides',
    content: [
      {
        link: 'https://www.homedepot.com/c/ai/how-to-start-a-flower-garden/9ba683603be9fa5395fab90db12ba2e',
        description: 'How to Start a Flower Garden'
      },
      {
        link: 'https://www.homedepot.com/c/ai/how-to-maintain-a-raised-garden-bed/9ba683603be9fa5395fab90b72df4a4',
        description: 'How to Maintain a Raised Garden Bed'
      }
    ]
  },
  {
    title: 'Garden Club',
    content: [
      {
        link: 'https://www.homedepot.com/c/ai/how-to-pick-the-right-color-mulch/9ba683603be9fa5395fab901168f14ce',
        description: 'How to Pick the Right Color Mulch'
      },
      {
        link: 'https://www.homedepot.com/c/ai/how-to-prepare-your-garden-for-a-season-of-flowers/9ba683603be9fa5395fab9016346a8ec',
        description: 'How to Prepare Your Garden for a Season of Flowers'
      },
      {
        link: 'https://www.homedepot.com/c/ai/how-to-grow-a-berry-garden-in-your-backyard/9ba683603be9fa5395fab901a4b79602',
        description: 'How to Grow a Berry Garden in Your Backyard'
      }
    ]
  },
  {
    title: 'View All Garden Guides',
    content: [
      {
        link: 'https://www.homedepot.com/c/alp/outdoor-living-ideas-garden-ideas-projects/157n-o4v9',
        description: 'Garden Ideas'
      },
    ]
  },
  {
    title: 'Join Garden Club',
    content: [
      {
        link: 'https://pages.homedepot.com/garden',
        description: 'Garden Club'
      }
    ]
  }
];
